'use strict';

module.exports = function(app) {

    app.notificationLoad = function(path) {
        var wrapper = $('.notification-panel');

        // Preloader
        wrapper.html($('.js-preloader-wrap').find('.notification-footer').clone());

        $.ajax({
            url: path
        }).done(function(data) {
            wrapper.html(data);
        });
    };

    return app;
};
